import React from 'react';
import Box from '@bit/knotchinc.web-react-components.box';
import { SlideToggle } from 'components/Global/Buttons';
import { SettingsLabelInline } from './styled.js';

const fetchCacheCookie = localStorage.getItem('fetchCache');

class FetchCacheToggle extends React.Component {
  constructor() {
    super();
    this.state = {
      toggled: fetchCacheCookie ? JSON.parse(fetchCacheCookie).toggled : true,
    };
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    window.fetchCache.toggle();
    this.setState(prevState => ({ toggled: !prevState.toggled }));
  }

  render() {
    const { toggled } = this.state;

    return (
      <Box width="300px" m="30px auto 25px auto">
        <SettingsLabelInline>[Dev] Cache data requests</SettingsLabelInline>
        <SlideToggle toggled={toggled} toggleHandler={() => this.handleToggle()} />
      </Box>
    );
  }
}

export default FetchCacheToggle;
